import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";



// Get Table Data
export const WTPEquipmentTypeTableDataAPI = createAsyncThunk("WTPEquipmentTypeTableData", async ({ data }) => {
    const {
        UserID,
        token,
        From,
        To,
        M_WTP_EquipmentTypeID,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_EquipmentType_Select?M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_UserID=${UserID ? UserID : '0'}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPEquipmentTypeTableDataSlice = createSlice({
    name: "WTPEquipmentTypeTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentTypeTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPEquipmentTypeTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPEquipmentTypeTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPEquipmentTypeTableDataReducer = WTPEquipmentTypeTableDataSlice.reducer


// Get Table Data
export const WTPEquipmentTypeExportTableDataAPI = createAsyncThunk("WTPEquipmentTypeExportTableData", async ({ data }) => {
    const {
        UserID,
        token,
        From,
        To,
        M_AssetTypeID,
        M_WardID,
        M_GD_SectorID,
        M_AssetID,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_M_Asset_Select?M_AssetTypeID=${M_AssetTypeID}&M_AssetID=${M_AssetID}&M_WardID=${M_WardID ? M_WardID : '0'}&M_GD_SectorID=${M_GD_SectorID ? M_GD_SectorID : '0'}&M_UsersID=${UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPEquipmentTypeExportTableDataSlice = createSlice({
    name: "WTPEquipmentTypeExportTableData",
    initialState: {
        isExportLoading: false,
        GardenExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentTypeExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPEquipmentTypeExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.GardenExporttableData = action.payload;
        });
        builder.addCase(WTPEquipmentTypeExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.GardenExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPEquipmentTypeExportTableDataReducer = WTPEquipmentTypeExportTableDataSlice.reducer


// InsertUpdate Table Data

export const WTPEquipmentTypePostDataAPI = createAsyncThunk("WTPEquipmentTypePostData", async ({ data }) => {
    const {
        M_WTP_EquipmentTypeID,
        EquipmentType,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_EquipmentTypeID", M_WTP_EquipmentTypeID);
    formdata.append("EquipmentType", EquipmentType);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/Master/Post_WEB_M_WTP_EquipmentType_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                // handleOnCloseClick()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WTPEquipmentTypePostDataSlice = createSlice({
    name: "WTPEquipmentTypePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentTypePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPEquipmentTypePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPEquipmentTypePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPEquipmentTypePostDataReducer = WTPEquipmentTypePostDataSlice.reducer



// Delete Table Data

export const WTPEquipmentTypeDeleteAPI = createAsyncThunk("WTPEquipmentTypeDelete", async ({ data }) => {

    const {
        M_WTP_EquipmentTypeID,
        M_UserID,
        handleIsPost,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_EquipmentTypeID", M_WTP_EquipmentTypeID);
    formdata.append("M_UserID", M_UserID);
    
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/Master/WEB_M_WTP_EquipmentType_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WTPEquipmentTypeDeleteSlice = createSlice({
    name: "WTPEquipmentTypeDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentTypeDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPEquipmentTypeDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WTPEquipmentTypeDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPEquipmentTypeDeleteReducer = WTPEquipmentTypeDeleteSlice.reducer